import React, { useState } from 'react'
import { Panel, Form, Col, Message, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ApproveProposalForm from '../../components/forms/approveProposalForm/ApproveProposalForm'
import { startLoading, doneLoading } from '../../utils/loading'
import { submiProjectSecureApproveMultiByType } from '../../redux/actions/multiApprove'
import ConfirmWidget from '../confirm/ConfirmWidget'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { ERR_MSG, RETRY_CONTACT_ADMIN } from '../../constants/msgText'
import CoiApproveProjectWidget from '../coi/CoiApproveProjectWidget'

export default function ApproveProposalMultiWidget({
  schema,
  projectVersionIdList,
  onComplete = () => {},
  buttonWidth,
  approveStatus,
  approveType,
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState()
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [checkCOI, setCheckCOI] = useState(false)

  const [formSchema, setFormSchema] = useState(schema)

  const handleSaveApproveProject = async (request) => {
    startLoading()
    setIsLoading(true)
    setErrorMessage(null)
    try {
      if (approveStatus != undefined) {
        let _schema = await submiProjectSecureApproveMultiByType(
          request,
          approveType,
          approveStatus == 1 ? 'Approve' : 'Reject'
        )

        if (_schema.success) {
          setFormSchema(_schema)
          window.location.href = _schema.secureApprovalUri
        } else {
          setErrorMessage(_schema.error)
        }
      } else {
        setErrorMessage('ไม่รองรับ approveStatus undefined')
      }

      // doneLoading()
      // onComplete()
    } catch (e) {
      if (e.response && e.response.data && e.response.data.status == 401) {
        setErrorMessage(e.response.data.exception)
      } else {
        setErrorMessage(
          `${ERR_MSG}ในการ${formSchema.buttonApproveProposalLabel} ${RETRY_CONTACT_ADMIN}`
        )
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = () => {
    setIsShowConfimModal(true)
  }

  const handleOnConfirmModal = (data) => {
    const requestData = {
      value: data.remark,
      //selected: approveStatus,
      // projectVersionIds: projectVersionIdList,
    }
    handleSaveApproveProject(requestData)
    setIsShowConfimModal(false)
  }

  return (
    <>
      <Form fluid>
        <Panel
          shaded
          header={formSchema.headerApproveProposal}
          bordered
          collapsible
          defaultExpanded
        >
          <>
            {formSchema.alert && (
              <>
                <Message showIcon type="warning" description={formSchema.alert} />
                <br />
              </>
            )}
            <ApproveProposalForm
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />

            {approveType == 1 && (
              <CoiApproveProjectWidget
                check={checkCOI}
                onCheck={(check) => setCheckCOI(check)}
                disabled={formSchema.disabled || isLoading}
              />
            )}

            {errorMessage && (
              <Row style={{ marginBottom: 10 }}>
                <Message showIcon type="error" description={errorMessage} />
              </Row>
            )}

            <Col style={{ marginBottom: 20, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
              <SaveButton
                onClick={handleSubmit(onSubmit)}
                style={{ marginLeft: 10 }}
                disabled={
                  isLoading ||
                  formSchema.disabled ||
                  !projectVersionIdList ||
                  projectVersionIdList?.length == 0 ||
                  (approveType == 1 && !checkCOI)
                }
              >
                {formSchema.buttonApproveProposalLabel}
              </SaveButton>
            </Col>
          </>
        </Panel>

        <ConfirmWidget
          title={`ยืนยัน${formSchema.buttonApproveProposalLabel}`}
          show={isShowConfimModal}
          detail={`กรุณายืนยัน${formSchema.buttonApproveProposalLabel}`}
          onCancle={() => setIsShowConfimModal(false)}
          onConfirm={handleSubmit(handleOnConfirmModal)}
        />
      </Form>
    </>
  )
}
